import Flex from "@/components/atoms/Flex";
import changelogs from "@/constants/changelogs";
import { createMarkup } from "@/helpers/utils";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";
import { Alert, Card } from "react-bootstrap";

const ChangeLogView: FC = () => {
  return (
    <div>
      {changelogs.map(({ version, title, warning, date, logs }, index) => (
        <Card className="mb-3" key={index}>
          <Card.Header>
            <h5>
              <code className="fw-bold fs-1">v{version}</code> - {title}{" "}
            </h5>
            <p className="mb-0">{date}</p>
          </Card.Header>
          <Card.Body className="bg-light">
            {warning && (
              <Alert variant="warning" className="p-card">
                <Flex>
                  <FontAwesomeIcon
                    icon={faExclamationTriangle}
                    className="fs-3"
                  />
                  <div className="ms-3 flex-1">
                    <h4 className="alert-heading">{warning.title}</h4>
                    {warning.text && <p className="mb-0">{warning.text}</p>}
                  </div>
                </Flex>
              </Alert>
            )}
            {Object.keys(logs).map((value, index) => (
              <div key={index}>
                <h5 className="fs-0">{value}</h5>
                <ul className="ps-3">
                  {logs[value].map((v, i) => (
                    <li key={i} dangerouslySetInnerHTML={createMarkup(v)} />
                  ))}
                </ul>
              </div>
            ))}
          </Card.Body>
        </Card>
      ))}
    </div>
  );
};

export default ChangeLogView;
